import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ErrCode } from 'src/app/shared/models';

@Component({
    selector: 'app-link-error',
    templateUrl: './link-error.component.html',
    styleUrls: ['link-error.component.scss']
})
export class LinkErrorComponent implements OnInit {

    public key: string;
    public errorHeader: string;
    @Output() linkkey = new EventEmitter<string>();

    @Input() errcode: ErrCode;
    constructor(private router: Router) { }

    ngOnInit() {
        if (this.errcode.code === 8020) {
            this.errorHeader = 'Expired link';
        }
        if (this.errcode.code === 8021) {
            this.errorHeader = 'Download limit reached';
        }
    }

    public setKey() {
        this.linkkey.emit(this.key);
    }

    public redirectToLogin = () => {
        this.router.navigate(['/login']);
    }
}
